const getters = {
  lang: state => state.app.lang
}

export default getters
